import React from 'react';
import './footer.css';
import FooterNavItem from '../common/footernavitem';
import footerDecor from '../../assets/imgs/footerBook.png';

const Footer = () => {
    return ( <>
    <footer>
        <nav>
            <img src={footerDecor} alt="Book and Cairo International Book Fair ticket" />
            <ul>
                <FooterNavItem footerNavItemLink="/" footerNavItem="Home" footerNavItemStyle="link footerNavItem" />
                <FooterNavItem footerNavItemLink="/Book" footerNavItem="Book" footerNavItemStyle="link footerNavItem" />
                <FooterNavItem footerNavItemLink="/Explore" footerNavItem="Explore" footerNavItemStyle="link footerNavItem" />
                <FooterNavItem footerNavItemLink="/History" footerNavItem="History" footerNavItemStyle="link footerNavItem" />
                <FooterNavItem footerNavItemLink="/Info" footerNavItem="Info" footerNavItemStyle="link footerNavItem" />
            </ul>
        </nav>
        <div className="copyrightsCont">
            <p>© 2026 Cairo International Book Fair. All rights reserved.</p>
            <div className="copyrights">
                <p>Privacy Policy</p>
                <p>Terms of Service</p>
                <p>Cookies</p>
            </div>
        </div>
    </footer>
    </> );
}
 
export default Footer;